<app-modal
  [title]="data?.displayName || data?.name"
  maxWidth="1200px"
  minWidth="30%"
  width="fit-content"
  [compact]="true"
>
  <ng-template>
    <div>
      <p class="p3 m-b-8">
        {{ 'Enter the price' | trans:'kiosk/product-price-picker-modal/prompt.Text' }}
      </p>

      <app-content-editable-input (valueChange)="amountRaw.set($event)" />
    </div>

    <div class="m-t-24">
      <app-content-box theme="gray">
        <app-keyboard
          [isSimple]="false"
          (clear)="handleKeyboardClear()"
          (deleteBack)="handleKeyboardDeleteBack()"
          (keyClick)="handleKeyboardKeyClick($event)"
        />
      </app-content-box>
    </div>
  </ng-template>

  <ng-container modal-buttons>
    <div class="d-flex gap-16 m-t-16 justify-content-flex-end">
      <button
        class="button button--md button--primary-ghost text-uppercase"
        type="button"
        (click)="close()"
      >
        {{ 'Cancel' | trans:'kiosk/product-price-picker-modal/cancel.Button' }}
      </button>
      <button
        #btn
        class="button button--md button--primary text-uppercase"
        type="button"
        [disabled]="isConfirmDisabled()"
        (click)="addProductToCart(btn)"
      >
        {{ 'Confirm' | trans:'kiosk/product-price-picker-modal/confirm.Button' }}
      </button>
    </div>
  </ng-container>
</app-modal>
